import { useEffect, useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import DutyPostingService from "../services/dutyposting,service";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Modal, Button } from "react-bootstrap";
import AuthService from "../services/auth.service";
import DutyDetails from "./DutyDetails";
import ExtraDutyLogsheet from "./ExtraDutyLogsheet";

const debounce = (func, delay) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func.apply(null, args);
    }, delay);
  };
};

const ExtraDuty = ({
  depo,
  fetchExtraDutys,
  extraDuty,
  setExtraDuty,
  draggedCondDatas,
  setDraggedCondDatas,
  draggedDrvDatas,
  setDraggedDrvDatas,
  getDrvList,
}) => {
  const [data, setData] = useState([]);

  const [search, setSearch] = useState("");

  const [show, setShow] = useState(false);

  const [filter, setFilter] = useState(false);
  const [filteredData, setFilteredData] = useState([]);

  const [busList, setBusList] = useState([]);
  const [showBusList, setShowBusList] = useState(false);

  const [edit, setEdit] = useState(false);
  const [show2, setShow2] = useState(false);
  const [show3, setShow3] = useState(false);
  const [show4, setShow4] = useState(false);

  const [editDutyNo, setEditDutyNo] = useState(null);

  const [dutyData, setDutyData] = useState({});
  const [selectedDrv, setSelectedDrv] = useState("");
  const [selectedCon, setSelectedCon] = useState("");
  const [selectedReason, setSelectedReason] = useState("9");
  const [selectBus, setSelectBus] = useState(false);

  const [details, setDetails] = useState({
    dutyNo: "",
    driverNO: "",
    conductorNo: "",
    delayReason: "9",
    busNo: "",
    time: "",
    narration: "",
  });

  const [isDrvChange, setIsDrvChange] = useState(false);
  const [isCondChange, setIsCondChange] = useState(false);

  const [changedDuty, setChangedDuty] = useState("");

  const checkCrewNo = (empCode, crewid, workno, extraDuty) => {
    const payload = {
      empCode: empCode,
      crewid: crewid,
    };

    const payloadNew = {
      empoCode: empCode,
      empType: crewid,
    };

    DutyPostingService.checkCrewMannualyNew(payloadNew)
      .then((resp) => {
        if (resp.data.locId === "10") {
          DutyPostingService.checkCrewMannualy(payload)
            .then((resp) => {
              // console.log(resp.data);
              const errorCodes = ["2", "0", "4"];
              const empType = `${crewid === "2" ? "Driver" : "Conductor"}`;
              const message =
                resp.data.status === "2" ? (
                  `${empType} is already allocated to another Duty!`
                ) : resp.data.status === "0" ? (
                  <>
                    <div className="d-flex flex-column">
                      <div>
                        {empType === "Driver" ? "चालक" : "वाहक"} उपस्थित नाही.
                      </div>
                      <div>{empType} is not available</div>
                    </div>
                  </>
                ) : resp.data.status === "4" ? (
                  <>
                    <div className="d-flex flex-column">
                      <div>
                        कृपया {empType === "Driver" ? "चालक" : "वाहक"} क्रमांक
                        तपासा.
                      </div>
                      <div>Please check the {empType} Number.</div>
                    </div>
                  </>
                ) : (
                  ""
                );
              if (errorCodes.includes(resp.data.status)) {
                toast.warn(message, {
                  position: "top-center",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                  theme: "light",
                });
                setIsCondChange(false);
                setIsDrvChange(false);

                fetchExtraDutys();
              } else if (resp.data.status === "1") {
                if (crewid === "1") {
                  const draggedCondData = JSON.parse(
                    localStorage.getItem("draggedCondData")
                  );

                  const message = (
                    <>
                      <div className="d-flex flex-column">
                        <div>
                          वाहक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.
                        </div>
                        <div>
                          Conductor code is already added to another duty.
                        </div>
                      </div>
                    </>
                  );

                  if (
                    draggedCondData &&
                    draggedCondData.filter(
                      (item) =>
                        item.condNo === empCode &&
                        item.workno !== dutyData.workno
                    ).length > 0
                  ) {
                    toast.warn(message, {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                  } else if (
                    draggedCondData.filter(
                      (item) =>
                        item.condNo === selectedCon &&
                        item.workno === dutyData.workno
                    ).length > 0
                  ) {
                    const newArr = extraDuty.map((item2, idx) => {
                      if (workno === item2.workno) {
                        return {
                          ...item2,
                          conductorNo: empCode,
                          conductorPresenty: "1",
                        };
                      }
                      return item2;
                    });
                    setIsCondChange(true);
                    setExtraDuty(newArr);
                    setChangedDuty(workno);
                  } else {
                    const newArr = extraDuty.map((item2, idx) => {
                      if (workno === item2.workno) {
                        return {
                          ...item2,
                          conductorNo: empCode,
                          conductorPresenty: "1",
                        };
                      }
                      return item2;
                    });
                    setIsCondChange(true);
                    setExtraDuty(newArr);
                    setChangedDuty(workno);
                    setDraggedCondDatas((prevValues) => {
                      const exists = prevValues.some(
                        (item) => item.workno === workno
                      );
                      if (exists) {
                        return prevValues.map((item) =>
                          item.workno === workno
                            ? { ...item, condNo: empCode }
                            : item
                        );
                      } else {
                        return [
                          ...prevValues,
                          {
                            workno: workno,
                            condNo: empCode,
                          },
                        ];
                      }
                    });
                  }
                } else if (crewid === "2") {
                  const draggedDrvData = JSON.parse(
                    localStorage.getItem("draggedDrvData")
                  );
                  if (
                    draggedDrvData &&
                    draggedDrvData.filter(
                      (item) =>
                        item.driverNo === empCode && item.workno !== workno
                    ).length > 0
                  ) {
                    const message = (
                      <>
                        <div className="d-flex flex-column">
                          <div>
                            चालक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.
                          </div>
                          <div>
                            Driver code is already added to another duty.
                          </div>
                        </div>
                      </>
                    );

                    toast.warn(message, {
                      position: "top-center",
                      autoClose: 3000,
                      hideProgressBar: false,
                      closeOnClick: true,
                      pauseOnHover: true,
                      draggable: true,
                      progress: undefined,
                      theme: "light",
                    });
                  } else {
                    const newArr = extraDuty.map((item2, idx) => {
                      if (workno === item2.workno) {
                        return {
                          ...item2,
                          driverNo: empCode,
                          driverPresenty: "1",
                        };
                      }
                      return item2;
                    });
                    setExtraDuty(newArr);
                    setShow4(false);
                    setIsDrvChange(true);
                    setChangedDuty(workno);
                    setDraggedDrvDatas((prevValues) => {
                      const exists = prevValues.some(
                        (item) => item.workno === workno
                      );
                      if (exists) {
                        return prevValues.map((item) =>
                          item.workno === workno
                            ? { ...item, driverNo: empCode }
                            : item
                        );
                      } else {
                        return [
                          ...prevValues,
                          {
                            workno: workno,
                            driverNo: empCode,
                          },
                        ];
                      }
                    });
                  }
                }
              }
            })
            .catch((e) => {
              console.log(e);
            });
        } else if (resp.data.locId !== "0") {
          if (crewid === "1") {
            const draggedCondData = JSON.parse(
              localStorage.getItem("draggedCondData")
            );

            if (
              draggedCondData &&
              draggedCondData.filter(
                (item) =>
                  item.condNo === empCode && item.workno !== dutyData.workno
              ).length > 0
            ) {
              const message = (
                <>
                  <div className="d-flex flex-column">
                    <div>वाहक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.</div>
                    <div>Conductor code is already added to another duty.</div>
                  </div>
                </>
              );

              toast.warn(message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else if (
              draggedCondData.filter(
                (item) =>
                  item.condNo === selectedCon && item.workno === dutyData.workno
              ).length > 0
            ) {
              const newArr = extraDuty.map((item2, idx) => {
                if (workno === item2.workno) {
                  return {
                    ...item2,
                    conductorNo: empCode,
                    conductorPresenty: "1",
                  };
                }
                return item2;
              });
              setIsCondChange(true);
              setExtraDuty(newArr);
              setChangedDuty(workno);
            } else {
              const newArr = extraDuty.map((item2, idx) => {
                if (workno === item2.workno) {
                  return {
                    ...item2,
                    conductorNo: empCode,
                    conductorPresenty: "1",
                  };
                }
                return item2;
              });
              setIsCondChange(true);
              setExtraDuty(newArr);
              setChangedDuty(workno);
              setDraggedCondDatas((prevValues) => {
                const exists = prevValues.some(
                  (item) => item.workno === workno
                );
                if (exists) {
                  return prevValues.map((item) =>
                    item.workno === workno ? { ...item, condNo: empCode } : item
                  );
                } else {
                  return [
                    ...prevValues,
                    {
                      workno: workno,
                      condNo: empCode,
                    },
                  ];
                }
              });
            }
          } else if (crewid === "2") {
            const draggedDrvData = JSON.parse(
              localStorage.getItem("draggedDrvData")
            );
            if (
              draggedDrvData &&
              draggedDrvData.filter(
                (item) => item.driverNo === empCode && item.workno !== workno
              ).length > 0
            ) {
              const message = (
                <>
                  <div className="d-flex flex-column">
                    <div>चालक क्रमांक आधीच दुसऱ्या ड्यूटीला जोडलेला आहे.</div>
                    <div>Driver code is already added to another duty.</div>
                  </div>
                </>
              );
              toast.warn(message, {
                position: "top-center",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
              });
            } else {
              const newArr = extraDuty.map((item2, idx) => {
                if (workno === item2.workno) {
                  return {
                    ...item2,
                    driverNo: empCode,
                    driverPresenty: "1",
                  };
                }
                return item2;
              });
              setExtraDuty(newArr);
              setShow4(false);
              setIsDrvChange(true);
              setChangedDuty(workno);
              setDraggedDrvDatas((prevValues) => {
                const exists = prevValues.some(
                  (item) => item.workno === workno
                );
                if (exists) {
                  return prevValues.map((item) =>
                    item.workno === workno
                      ? { ...item, driverNo: empCode }
                      : item
                  );
                } else {
                  return [
                    ...prevValues,
                    {
                      workno: workno,
                      driverNo: empCode,
                    },
                  ];
                }
              });
            }
          }
        } else {
          const empType = `${crewid === "2" ? "Driver" : "Conductor"}`;
          const message = (
            <>
              <div className="d-flex flex-column">
                <div>
                  कृपया {empType === "Driver" ? "चालक" : "वाहक"} क्रमांक तपासा.
                </div>
                <div>Please check the {empType} Number.</div>
              </div>
            </>
          );
          toast.warn(message, {
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
          setIsCondChange(false);
          setIsDrvChange(false);

          fetchExtraDutys();
        }
      })
      .catch((e) => console.log(e));
  };

  const debouncedCallCheckCrewNo = useCallback(debounce(checkCrewNo, 1500), []);

  console.log(
    "draggedDrvDatas, draggedCondDatas",
    draggedDrvDatas,
    draggedCondDatas
  );

  const handleInputChange = (e, key, srNo, workno) => {
    // const { name, value } = e.target;

    const value = e.target.value;

    console.log(value, key, srNo, workno);

    // setEdit(true);

    if (key === "workno") {
      const data = extraDuty.filter((item) => item.workno === value);
      console.log(data.length);
      if (data.length === 1) {
        toast.warn("Duty No. is already in used. Please try another.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        setExtraDuty((prevData) =>
          prevData.map((row) =>
            row.srNo === srNo ? { ...row, workno: "" } : row
          )
        );
      } else {
        setExtraDuty((prevData) =>
          prevData.map((row) =>
            row.srNo === srNo ? { ...row, workno: value } : row
          )
        );
      }
    } else if (key === "driverNo") {
      debouncedCallCheckCrewNo(value, "2", workno, extraDuty);
      setExtraDuty((prevData) =>
        prevData.map((row) =>
          row.srNo === srNo ? { ...row, [key]: value } : row
        )
      );
    } else if (key === "conductorNo") {
      debouncedCallCheckCrewNo(value, "1", workno, extraDuty);
      setExtraDuty((prevData) =>
        prevData.map((row) =>
          row.srNo === srNo ? { ...row, [key]: value } : row
        )
      );
    } else {
      setExtraDuty((prevData) =>
        prevData.map((row) =>
          row.srNo === srNo ? { ...row, [key]: value } : row
        )
      );
    }
  };

  console.log("extraDuty", extraDuty);

  const handleSearch = (e) => {
    setSearch(e.target.value);
    const keyword = e.target.value.toLowerCase();
    const filteredData = data.filter(
      (row) =>
        (row.dutyNo &&
          row.dutyNo.replace(/\s+/g, "").toLowerCase() === keyword) ||
        (row.delayReason &&
          row.delayReason.replace(/\s+/g, "").toLowerCase() === keyword)
    );

    if (keyword.length > 0) {
      setFilter(true);
    } else {
      setFilter(false);
    }
    setFilteredData(filteredData);
  };

  const fetchVehicleList = (value) => {
    const payload = {
      busNo: value,
    };

    DutyPostingService.getBusInfo(payload).then((resp) => {
      if (resp.data) {
        setBusList(resp.data);
      }
    });
  };

  const debouncedCallApi = useCallback(debounce(fetchVehicleList, 500), []);

  const handleSelectBusNo = (e, workno) => {
    const value = e.target.value;
    setEditDutyNo(workno);

    setExtraDuty((prevData) =>
      prevData.map((row, idx) =>
        row.workno === workno ? { ...row, busNo: value } : row
      )
    );

    if (value.length > 0) {
      setShowBusList(true);
    } else {
      setShowBusList(false);
    }

    debouncedCallApi(value);
  };

  const handleSelect = (e, index, value) => {
    e.preventDefault();

    setExtraDuty((prevData) =>
      prevData.map((row, idx) =>
        idx === index ? { ...row, busNo: value } : row
      )
    );

    setShowBusList(false);
  };

  const onDragStartCon = (event, conId, isPresent, type) => {
    setEdit(true);
    event.dataTransfer.setData("draggedItemIndex", conId);
    event.dataTransfer.setData("draggedItemIndexPresent", isPresent);
    event.dataTransfer.setData("draggedItemIndexType", type);
  };

  const onDropCon = (event, dropIndex) => {
    const draggedItemIndex = event.dataTransfer.getData("draggedItemIndex");
    const draggedItemIndexPresent = event.dataTransfer.getData(
      "draggedItemIndexPresent"
    );
    const draggedItemIndexType = event.dataTransfer.getData(
      "draggedItemIndexType"
    );
    if (draggedItemIndexType === "cond") {
      if (draggedItemIndexPresent === "1" || draggedItemIndexPresent === "3") {
        setShow3(true);
        setSelectedCon(draggedItemIndex);
        setDutyData(dropIndex);
      } else {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>वाहक उपस्थित नाही.</div>
              <div>Conductor is not Available!</div>
            </div>
          </>
        );
        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      // alert("Driver Selected");
      const message = (
        <>
          <div className="d-flex flex-column">
            <div>कृपया वाहक निवडा.</div>
            <div>Please select Conductor!</div>
          </div>
        </>
      );

      toast.warn(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const onDragStartDrv = (event, drvId, isPresent, type) => {
    setEdit(true);
    event.dataTransfer.setData("draggedItemIndex2", drvId);
    event.dataTransfer.setData("draggedItemIndexPresent2", isPresent);
    event.dataTransfer.setData("draggedItemIndexType2", type);
  };

  const onDropDrv = (event, dropIndex) => {
    const draggedItemIndex = event.dataTransfer.getData("draggedItemIndex2");
    const draggedItemIndexPresent = event.dataTransfer.getData(
      "draggedItemIndexPresent2"
    );
    const draggedItemIndexType = event.dataTransfer.getData(
      "draggedItemIndexType2"
    );

    if (draggedItemIndexType === "drv") {
      if (draggedItemIndexPresent === "1" || draggedItemIndexPresent === "3") {
        setShow4(true);
        setSelectedDrv(draggedItemIndex);
        setDutyData(dropIndex);
      } else {
        const message = (
          <>
            <div className="d-flex flex-column">
              <div>चालक उपस्थित नाही.</div>
              <div>Driver is not Available!</div>
            </div>
          </>
        );
        toast.warn(message, {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } else {
      const message = (
        <>
          <div className="d-flex flex-column">
            <div>कृपया चालक निवडा.</div>
            <div>Please select Driver!</div>
          </div>
        </>
      );

      toast.warn(message, {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const onDragOver = (event) => {
    event.preventDefault();
  };

  useEffect(() => {
    fetchExtraDutys();
  }, []);

  const addRow = () => {
    const newRow = {
      srNo: 1,
      workno: "",
      driverNo: "",
      conductorNo: "",
      delayReason: "9",
      busNo: "",
      timeTo: "",
    };
    const updatedRows = extraDuty.map((row) => ({
      ...row,
      srNo: row.srNo + 1,
    }));
    setEdit(true);

    setExtraDuty([newRow, ...updatedRows]);
  };

  const exColumns = [
    {
      name: (
        <div className="theadcol-flex">
          <span>Duty No</span>
        </div>
      ),
      selector: (row) => row.workno,
      sortable: true,
      cell: (row) => (
        <>
          <div className="routNo">
            {row.editsts === "1" ? (
              <>
                <span>{row.workno}</span>
              </>
            ) : (
              <>
                <input
                  className="custom-input"
                  style={{ width: "75px" }}
                  type="text"
                  value={row.workno}
                  onChange={(e) => handleInputChange(e, "workno", row.srNo)}
                />
              </>
            )}
          </div>
        </>
      ),
      // width: "115px",s
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Driver</span>
        </div>
      ),
      selector: (row) => row.driverNo,
      cell: (row, index) => {
        const data1 = draggedDrvDatas.filter(
          (item) => item.workno === row.workno
        );
        const data2 = draggedCondDatas.filter(
          (item) => item.workno === row.workno
        );
        return (
          <div
            className={
              row.dutyAllot === "1" && row.driVla === "1" ? "crew" : "crew"
            }
            onDrop={(event) => onDropDrv(event, row)}
          >
            <div className="crew-pic">
              <span>
                <svg
                  width="37"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.4376 10.889C25.4376 15.8146 22.4622 20.0418 18.5001 20.0418C14.5349 20.0418 11.5626 15.8146 11.5626 10.8874C11.5626 5.96333 14.1218 3.0835 18.5001 3.0835C22.8784 3.0835 25.4376 5.96179 25.4376 10.889ZM6.32401 31.0524C6.91755 31.7585 9.47363 33.9168 18.5001 33.9168C27.5266 33.9168 30.0811 31.7585 30.6762 31.054C30.7314 30.9862 30.7722 30.908 30.796 30.8239C30.8199 30.7399 30.8263 30.6519 30.8149 30.5653C30.6793 29.2055 29.4552 23.1252 18.5001 23.1252C7.54501 23.1252 6.32093 29.2055 6.18372 30.5653C6.17255 30.652 6.17924 30.7401 6.20336 30.8241C6.22749 30.9081 6.26855 30.9848 6.32401 31.0524Z"
                    fill="#D2CDDA"
                  />
                </svg>
              </span>
            </div>
            <div className="crew-info">
              <div className="other-info">
                <div className="crew-code">
                  <div
                    className={
                      row.editsts === "1" || data1.length > 0
                        ? "action active"
                        : "action"
                    }
                  >
                    {data1 && data1.length > 0 ? (
                      <>
                        <input
                          className="custom-input crew"
                          type="text"
                          value={data1[0].driverNo}
                          onChange={(e) =>
                            handleInputChange(e, "driverNo", data1[0].driverNo)
                          }
                        />
                      </>
                    ) : (
                      <>
                        <input
                          className="custom-input crew"
                          type="text"
                          value={row.driverNo}
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              "driverNo",
                              row.srNo,
                              row.workno
                            )
                          }
                        />
                      </>
                    )}
                  </div>
                  {(isDrvChange && changedDuty === row.workno) ||
                  (data1 && data1.length > 0 && row.editsts !== "1") ? (
                    <button
                      className="transperent"
                      title="undo"
                      onClick={(e) => {
                        resetDrv(row.workno);
                      }}
                    >
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2697_3748)">
                            <path
                              d="M6.78125 9.6875C5.82325 9.6875 4.88676 9.40342 4.09021 8.87118C3.29366 8.33895 2.67282 7.58246 2.30621 6.69738C1.9396 5.8123 1.84368 4.83838 2.03057 3.89878C2.21747 2.95919 2.67879 2.09611 3.3562 1.4187C4.03361 0.741293 4.89669 0.279971 5.83628 0.0930735C6.77588 -0.0938237 7.7498 0.00209872 8.63488 0.368711C9.51996 0.735323 10.2764 1.35616 10.8087 2.15271C11.3409 2.94926 11.625 3.88575 11.625 4.84375C11.6235 6.12792 11.1126 7.35906 10.2046 8.2671C9.29656 9.17515 8.06542 9.68597 6.78125 9.6875ZM6.78125 1.9375C6.20645 1.9375 5.64456 2.10795 5.16663 2.42729C4.6887 2.74664 4.3162 3.20053 4.09623 3.73158C3.87626 4.26263 3.81871 4.84698 3.93085 5.41073C4.04298 5.97449 4.31978 6.49234 4.72622 6.89878C5.13267 7.30523 5.65051 7.58202 6.21427 7.69416C6.77803 7.8063 7.36238 7.74875 7.89343 7.52878C8.42448 7.30881 8.87837 6.93631 9.19771 6.45838C9.51706 5.98045 9.6875 5.41856 9.6875 4.84375C9.6875 4.07297 9.38131 3.33375 8.83628 2.78872C8.29126 2.2437 7.55204 1.9375 6.78125 1.9375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M3.87502 15.4998H1.93752C1.71419 15.4998 1.49771 15.4227 1.32471 15.2815C1.15171 15.1402 1.03281 14.9436 0.988145 14.7248L0.019395 9.88101C-0.0233394 9.67201 0.0041038 9.45476 0.0974659 9.26295C0.190828 9.07115 0.344888 8.91552 0.535739 8.82023L4.02324 7.07648C4.25383 6.96163 4.5206 6.94309 4.76487 7.02494C5.00913 7.10678 5.21088 7.28231 5.32572 7.5129C5.44057 7.74349 5.45911 8.01026 5.37726 8.25453C5.29542 8.49879 5.11989 8.70054 4.8893 8.81539L2.06346 10.223L2.73189 13.5623H3.87502C4.13195 13.5623 4.37835 13.6643 4.56003 13.846C4.7417 14.0277 4.84377 14.2741 4.84377 14.531C4.84377 14.7879 4.7417 15.0343 4.56003 15.216C4.37835 15.3977 4.13195 15.4998 3.87502 15.4998Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M11.625 15.5001H7.75C7.49307 15.5001 7.24667 15.398 7.06499 15.2164C6.88331 15.0347 6.78125 14.7883 6.78125 14.5314C6.78125 14.2744 6.88331 14.028 7.06499 13.8463C7.24667 13.6647 7.49307 13.5626 7.75 13.5626H10.8306L11.4991 10.2233L8.67322 8.81572C8.55841 8.75947 8.45587 8.68104 8.37151 8.58496C8.28716 8.48888 8.22266 8.37706 8.18173 8.25593C8.1408 8.13481 8.12425 8.00678 8.13304 7.87923C8.14182 7.75168 8.17577 7.62713 8.23292 7.51276C8.29007 7.39839 8.3693 7.29646 8.46603 7.21286C8.56276 7.12926 8.67509 7.06563 8.79653 7.02564C8.91797 6.98566 9.04612 6.97011 9.1736 6.97989C9.30108 6.98967 9.42536 7.02459 9.53928 7.08263L13.0268 8.82638C13.2165 8.92141 13.3698 9.0761 13.4631 9.26669C13.5563 9.45728 13.5845 9.67322 13.5431 9.88135L12.5744 14.7251C12.5297 14.9439 12.4108 15.1406 12.2378 15.2818C12.0648 15.423 11.8483 15.5001 11.625 15.5001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 25.1875C23.2608 25.1875 22.3243 24.9034 21.5277 24.3712C20.7312 23.8389 20.1103 23.0825 19.7437 22.1974C19.3771 21.3123 19.2812 20.3384 19.4681 19.3988C19.655 18.4592 20.1163 17.5961 20.7937 16.9187C21.4711 16.2413 22.3342 15.78 23.2738 15.5931C24.2134 15.4062 25.1873 15.5021 26.0724 15.8687C26.9575 16.2353 27.7139 16.8562 28.2462 17.6527C28.7784 18.4493 29.0625 19.3858 29.0625 20.3438C29.061 21.6279 28.5502 22.8591 27.6421 23.7671C26.7341 24.6752 25.5029 25.186 24.2188 25.1875ZM24.2188 17.4375C23.644 17.4375 23.0821 17.608 22.6041 17.9273C22.1262 18.2466 21.7537 18.7005 21.5337 19.2316C21.3138 19.7626 21.2562 20.347 21.3683 20.9107C21.4805 21.4745 21.7573 21.9923 22.1637 22.3988C22.5702 22.8052 23.088 23.082 23.6518 23.1942C24.2155 23.3063 24.7999 23.2487 25.3309 23.0288C25.862 22.8088 26.3159 22.4363 26.6352 21.9584C26.9546 21.4804 27.125 20.9186 27.125 20.3438C27.125 19.573 26.8188 18.8338 26.2738 18.2887C25.7288 17.7437 24.9895 17.4375 24.2188 17.4375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M21.3125 31.0001H19.375C19.1517 31.0001 18.9352 30.923 18.7622 30.7818C18.5892 30.6406 18.4703 30.4439 18.4257 30.2251L17.4569 25.3813C17.4151 25.1729 17.443 24.9565 17.5363 24.7655C17.6296 24.5745 17.7832 24.4195 17.9733 24.3244L21.4608 22.5807C21.5747 22.5226 21.699 22.4877 21.8264 22.4779C21.9539 22.4682 22.0821 22.4837 22.2035 22.5237C22.325 22.5637 22.4373 22.6273 22.534 22.7109C22.6307 22.7945 22.71 22.8964 22.7671 23.0108C22.8243 23.1252 22.8582 23.2497 22.867 23.3773C22.8758 23.5048 22.8592 23.6329 22.8183 23.754C22.7774 23.8751 22.7129 23.9869 22.6285 24.083C22.5442 24.1791 22.4416 24.2575 22.3268 24.3138L19.501 25.7233L20.1694 29.0626H21.3125C21.5695 29.0626 21.8159 29.1646 21.9976 29.3463C22.1792 29.528 22.2813 29.7744 22.2813 30.0313C22.2813 30.2883 22.1792 30.5347 21.9976 30.7163C21.8159 30.898 21.5695 31.0001 21.3125 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M29.0625 31.0001H25.1875C24.9306 31.0001 24.6842 30.898 24.5025 30.7164C24.3208 30.5347 24.2188 30.2883 24.2188 30.0314C24.2188 29.7744 24.3208 29.528 24.5025 29.3463C24.6842 29.1647 24.9306 29.0626 25.1875 29.0626H28.2681L28.9366 25.7233L26.1107 24.3157C25.9959 24.2595 25.8934 24.181 25.809 24.085C25.7247 23.9889 25.6602 23.8771 25.6192 23.7559C25.5783 23.6348 25.5617 23.5068 25.5705 23.3792C25.5793 23.2517 25.6133 23.1271 25.6704 23.0128C25.7276 22.8984 25.8068 22.7965 25.9035 22.7129C26.0003 22.6293 26.1126 22.5656 26.234 22.5256C26.3555 22.4857 26.4836 22.4701 26.6111 22.4799C26.7386 22.4897 26.8629 22.5246 26.9768 22.5826L30.4643 24.3264C30.654 24.4214 30.8073 24.5761 30.9006 24.7667C30.9938 24.9573 31.022 25.1732 30.9806 25.3814L30.0119 30.2251C29.9672 30.4439 29.8483 30.6406 29.6753 30.7818C29.5023 30.923 29.2858 31.0001 29.0625 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 13.5625C23.9618 13.5625 23.7154 13.4604 23.5337 13.2788C23.3521 13.0971 23.25 12.8507 23.25 12.5938V10.6562C23.2485 9.37208 22.7376 8.14095 21.8296 7.2329C20.9216 6.32485 19.6904 5.81404 18.4062 5.8125H16.4688C16.2118 5.8125 15.9654 5.71044 15.7837 5.52876C15.6021 5.34708 15.5 5.10068 15.5 4.84375C15.5 4.58682 15.6021 4.34042 15.7837 4.15874C15.9654 3.97706 16.2118 3.875 16.4688 3.875H18.4062C20.2041 3.87705 21.9278 4.59216 23.1991 5.86345C24.4703 7.13473 25.1854 8.85838 25.1875 10.6562V12.5938C25.1875 12.8507 25.0854 13.0971 24.9038 13.2788C24.7221 13.4604 24.4757 13.5625 24.2188 13.5625Z"
                              fill="#F98585"
                            />
                            <path
                              d="M16.4688 7.75018C16.2119 7.75013 15.9655 7.64803 15.7839 7.46634L13.8464 5.52884C13.6648 5.34717 13.5627 5.10081 13.5627 4.84393C13.5627 4.58706 13.6648 4.34069 13.8464 4.15903L15.7839 2.22153C15.8732 2.129 15.9801 2.0552 16.0983 2.00443C16.2165 1.95366 16.3436 1.92694 16.4723 1.92582C16.6009 1.9247 16.7285 1.94921 16.8475 1.99792C16.9666 2.04663 17.0747 2.11856 17.1657 2.20952C17.2567 2.30048 17.3286 2.40864 17.3773 2.5277C17.426 2.64675 17.4505 2.77432 17.4494 2.90295C17.4483 3.03158 17.4216 3.1587 17.3708 3.27689C17.32 3.39508 17.2462 3.50198 17.1537 3.59134L15.9011 4.84393L17.1537 6.09653C17.2891 6.23201 17.3814 6.4046 17.4187 6.59249C17.4561 6.78039 17.4369 6.97514 17.3636 7.15213C17.2903 7.32912 17.1662 7.4804 17.0069 7.58685C16.8476 7.6933 16.6604 7.75014 16.4688 7.75018Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 27.125H10.6562C9.37208 27.1235 8.14095 26.6126 7.2329 25.7046C6.32485 24.7966 5.81404 23.5654 5.8125 22.2812V18.4062C5.8125 18.1493 5.91456 17.9029 6.09624 17.7212C6.27792 17.5396 6.52432 17.4375 6.78125 17.4375C7.03818 17.4375 7.28458 17.5396 7.46626 17.7212C7.64794 17.9029 7.75 18.1493 7.75 18.4062V22.2812C7.75 23.052 8.05619 23.7913 8.60122 24.3363C9.14625 24.8813 9.88546 25.1875 10.6562 25.1875H12.5938C12.8507 25.1875 13.0971 25.2896 13.2788 25.4712C13.4604 25.6529 13.5625 25.8993 13.5625 26.1562C13.5625 26.4132 13.4604 26.6596 13.2788 26.8413C13.0971 27.0229 12.8507 27.125 12.5938 27.125Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 29.0623C12.4022 29.0623 12.215 29.0054 12.0557 28.899C11.8964 28.7925 11.7723 28.6413 11.699 28.4643C11.6257 28.2873 11.6065 28.0925 11.6438 27.9046C11.6812 27.7167 11.7734 27.5441 11.9089 27.4087L13.1615 26.1561L11.9089 24.9035C11.7324 24.7208 11.6348 24.4761 11.637 24.2221C11.6392 23.968 11.7411 23.7251 11.9207 23.5455C12.1003 23.3658 12.3433 23.264 12.5973 23.2618C12.8513 23.2595 13.096 23.3572 13.2787 23.5337L15.2162 25.4712C15.3978 25.6528 15.4998 25.8992 15.4998 26.1561C15.4998 26.4129 15.3978 26.6593 15.2162 26.841L13.2787 28.7785C13.0971 28.9602 12.8507 29.0623 12.5938 29.0623Z"
                              fill="#F98585"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2697_3748">
                              <rect width="31" height="31" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  ) : null}
                  <ExtraDutyLogsheet
                    data={row}
                    depo={depo}
                    fetchData={fetchExtraDutys}
                    data1={data1}
                    data2={data2}
                    isDrv={true}
                    isCond={false}
                    isPresent={row.editsts === "1" ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Conductor </span>
        </div>
      ),
      selector: (row) => row.conductorNo,
      cell: (row, index) => {
        const data1 = draggedDrvDatas.filter(
          (item) => item.workno === row.workno
        );
        const data2 = draggedCondDatas.filter(
          (item) => item.workno === row.workno
        );

        return (
          <div className={"crew"} onDrop={(event) => onDropCon(event, row)}>
            <div className="crew-pic">
              <span>
                <svg
                  width="37"
                  height="37"
                  viewBox="0 0 37 37"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M25.4376 10.889C25.4376 15.8146 22.4622 20.0418 18.5001 20.0418C14.5349 20.0418 11.5626 15.8146 11.5626 10.8874C11.5626 5.96333 14.1218 3.0835 18.5001 3.0835C22.8784 3.0835 25.4376 5.96179 25.4376 10.889ZM6.32401 31.0524C6.91755 31.7585 9.47363 33.9168 18.5001 33.9168C27.5266 33.9168 30.0811 31.7585 30.6762 31.054C30.7314 30.9862 30.7722 30.908 30.796 30.8239C30.8199 30.7399 30.8263 30.6519 30.8149 30.5653C30.6793 29.2055 29.4552 23.1252 18.5001 23.1252C7.54501 23.1252 6.32093 29.2055 6.18372 30.5653C6.17255 30.652 6.17924 30.7401 6.20336 30.8241C6.22749 30.9081 6.26855 30.9848 6.32401 31.0524Z"
                    fill="#D2CDDA"
                  />
                </svg>
              </span>
            </div>
            <div className="crew-info">
              <div className="other-info">
                <div className="crew-code">
                  <div
                    className={
                      row.editsts === "1" || data2.length > 0
                        ? "action active"
                        : "action"
                    }
                  >
                    {data2 && data2.length > 0 ? (
                      <>
                        <input
                          className="custom-input crew"
                          type="text"
                          value={data2[0].condNo}
                          onChange={(e) =>
                            handleInputChange(e, "conductorNo", data2[0].condNo)
                          }
                        />
                      </>
                    ) : (
                      <>
                        <input
                          className="custom-input crew"
                          type="text"
                          value={row.conductorNo}
                          onChange={(e) =>
                            handleInputChange(
                              e,
                              "conductorNo",
                              row.srNo,
                              row.workno
                            )
                          }
                        />
                      </>
                    )}
                  </div>
                  {(isCondChange && changedDuty === row.workno) ||
                  (data2 && data2.length > 0 && row.editsts !== "1") ? (
                    <button
                      className="transperent"
                      title="undo"
                      onClick={(e) => {
                        resetCond(row.workno);
                      }}
                    >
                      <span>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 31 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g clip-path="url(#clip0_2697_3748)">
                            <path
                              d="M6.78125 9.6875C5.82325 9.6875 4.88676 9.40342 4.09021 8.87118C3.29366 8.33895 2.67282 7.58246 2.30621 6.69738C1.9396 5.8123 1.84368 4.83838 2.03057 3.89878C2.21747 2.95919 2.67879 2.09611 3.3562 1.4187C4.03361 0.741293 4.89669 0.279971 5.83628 0.0930735C6.77588 -0.0938237 7.7498 0.00209872 8.63488 0.368711C9.51996 0.735323 10.2764 1.35616 10.8087 2.15271C11.3409 2.94926 11.625 3.88575 11.625 4.84375C11.6235 6.12792 11.1126 7.35906 10.2046 8.2671C9.29656 9.17515 8.06542 9.68597 6.78125 9.6875ZM6.78125 1.9375C6.20645 1.9375 5.64456 2.10795 5.16663 2.42729C4.6887 2.74664 4.3162 3.20053 4.09623 3.73158C3.87626 4.26263 3.81871 4.84698 3.93085 5.41073C4.04298 5.97449 4.31978 6.49234 4.72622 6.89878C5.13267 7.30523 5.65051 7.58202 6.21427 7.69416C6.77803 7.8063 7.36238 7.74875 7.89343 7.52878C8.42448 7.30881 8.87837 6.93631 9.19771 6.45838C9.51706 5.98045 9.6875 5.41856 9.6875 4.84375C9.6875 4.07297 9.38131 3.33375 8.83628 2.78872C8.29126 2.2437 7.55204 1.9375 6.78125 1.9375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M3.87502 15.4998H1.93752C1.71419 15.4998 1.49771 15.4227 1.32471 15.2815C1.15171 15.1402 1.03281 14.9436 0.988145 14.7248L0.019395 9.88101C-0.0233394 9.67201 0.0041038 9.45476 0.0974659 9.26295C0.190828 9.07115 0.344888 8.91552 0.535739 8.82023L4.02324 7.07648C4.25383 6.96163 4.5206 6.94309 4.76487 7.02494C5.00913 7.10678 5.21088 7.28231 5.32572 7.5129C5.44057 7.74349 5.45911 8.01026 5.37726 8.25453C5.29542 8.49879 5.11989 8.70054 4.8893 8.81539L2.06346 10.223L2.73189 13.5623H3.87502C4.13195 13.5623 4.37835 13.6643 4.56003 13.846C4.7417 14.0277 4.84377 14.2741 4.84377 14.531C4.84377 14.7879 4.7417 15.0343 4.56003 15.216C4.37835 15.3977 4.13195 15.4998 3.87502 15.4998Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M11.625 15.5001H7.75C7.49307 15.5001 7.24667 15.398 7.06499 15.2164C6.88331 15.0347 6.78125 14.7883 6.78125 14.5314C6.78125 14.2744 6.88331 14.028 7.06499 13.8463C7.24667 13.6647 7.49307 13.5626 7.75 13.5626H10.8306L11.4991 10.2233L8.67322 8.81572C8.55841 8.75947 8.45587 8.68104 8.37151 8.58496C8.28716 8.48888 8.22266 8.37706 8.18173 8.25593C8.1408 8.13481 8.12425 8.00678 8.13304 7.87923C8.14182 7.75168 8.17577 7.62713 8.23292 7.51276C8.29007 7.39839 8.3693 7.29646 8.46603 7.21286C8.56276 7.12926 8.67509 7.06563 8.79653 7.02564C8.91797 6.98566 9.04612 6.97011 9.1736 6.97989C9.30108 6.98967 9.42536 7.02459 9.53928 7.08263L13.0268 8.82638C13.2165 8.92141 13.3698 9.0761 13.4631 9.26669C13.5563 9.45728 13.5845 9.67322 13.5431 9.88135L12.5744 14.7251C12.5297 14.9439 12.4108 15.1406 12.2378 15.2818C12.0648 15.423 11.8483 15.5001 11.625 15.5001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 25.1875C23.2608 25.1875 22.3243 24.9034 21.5277 24.3712C20.7312 23.8389 20.1103 23.0825 19.7437 22.1974C19.3771 21.3123 19.2812 20.3384 19.4681 19.3988C19.655 18.4592 20.1163 17.5961 20.7937 16.9187C21.4711 16.2413 22.3342 15.78 23.2738 15.5931C24.2134 15.4062 25.1873 15.5021 26.0724 15.8687C26.9575 16.2353 27.7139 16.8562 28.2462 17.6527C28.7784 18.4493 29.0625 19.3858 29.0625 20.3438C29.061 21.6279 28.5502 22.8591 27.6421 23.7671C26.7341 24.6752 25.5029 25.186 24.2188 25.1875ZM24.2188 17.4375C23.644 17.4375 23.0821 17.608 22.6041 17.9273C22.1262 18.2466 21.7537 18.7005 21.5337 19.2316C21.3138 19.7626 21.2562 20.347 21.3683 20.9107C21.4805 21.4745 21.7573 21.9923 22.1637 22.3988C22.5702 22.8052 23.088 23.082 23.6518 23.1942C24.2155 23.3063 24.7999 23.2487 25.3309 23.0288C25.862 22.8088 26.3159 22.4363 26.6352 21.9584C26.9546 21.4804 27.125 20.9186 27.125 20.3438C27.125 19.573 26.8188 18.8338 26.2738 18.2887C25.7288 17.7437 24.9895 17.4375 24.2188 17.4375Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M21.3125 31.0001H19.375C19.1517 31.0001 18.9352 30.923 18.7622 30.7818C18.5892 30.6406 18.4703 30.4439 18.4257 30.2251L17.4569 25.3813C17.4151 25.1729 17.443 24.9565 17.5363 24.7655C17.6296 24.5745 17.7832 24.4195 17.9733 24.3244L21.4608 22.5807C21.5747 22.5226 21.699 22.4877 21.8264 22.4779C21.9539 22.4682 22.0821 22.4837 22.2035 22.5237C22.325 22.5637 22.4373 22.6273 22.534 22.7109C22.6307 22.7945 22.71 22.8964 22.7671 23.0108C22.8243 23.1252 22.8582 23.2497 22.867 23.3773C22.8758 23.5048 22.8592 23.6329 22.8183 23.754C22.7774 23.8751 22.7129 23.9869 22.6285 24.083C22.5442 24.1791 22.4416 24.2575 22.3268 24.3138L19.501 25.7233L20.1694 29.0626H21.3125C21.5695 29.0626 21.8159 29.1646 21.9976 29.3463C22.1792 29.528 22.2813 29.7744 22.2813 30.0313C22.2813 30.2883 22.1792 30.5347 21.9976 30.7163C21.8159 30.898 21.5695 31.0001 21.3125 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M29.0625 31.0001H25.1875C24.9306 31.0001 24.6842 30.898 24.5025 30.7164C24.3208 30.5347 24.2188 30.2883 24.2188 30.0314C24.2188 29.7744 24.3208 29.528 24.5025 29.3463C24.6842 29.1647 24.9306 29.0626 25.1875 29.0626H28.2681L28.9366 25.7233L26.1107 24.3157C25.9959 24.2595 25.8934 24.181 25.809 24.085C25.7247 23.9889 25.6602 23.8771 25.6192 23.7559C25.5783 23.6348 25.5617 23.5068 25.5705 23.3792C25.5793 23.2517 25.6133 23.1271 25.6704 23.0128C25.7276 22.8984 25.8068 22.7965 25.9035 22.7129C26.0003 22.6293 26.1126 22.5656 26.234 22.5256C26.3555 22.4857 26.4836 22.4701 26.6111 22.4799C26.7386 22.4897 26.8629 22.5246 26.9768 22.5826L30.4643 24.3264C30.654 24.4214 30.8073 24.5761 30.9006 24.7667C30.9938 24.9573 31.022 25.1732 30.9806 25.3814L30.0119 30.2251C29.9672 30.4439 29.8483 30.6406 29.6753 30.7818C29.5023 30.923 29.2858 31.0001 29.0625 31.0001Z"
                              fill="#EF0B0B"
                            />
                            <path
                              d="M24.2188 13.5625C23.9618 13.5625 23.7154 13.4604 23.5337 13.2788C23.3521 13.0971 23.25 12.8507 23.25 12.5938V10.6562C23.2485 9.37208 22.7376 8.14095 21.8296 7.2329C20.9216 6.32485 19.6904 5.81404 18.4062 5.8125H16.4688C16.2118 5.8125 15.9654 5.71044 15.7837 5.52876C15.6021 5.34708 15.5 5.10068 15.5 4.84375C15.5 4.58682 15.6021 4.34042 15.7837 4.15874C15.9654 3.97706 16.2118 3.875 16.4688 3.875H18.4062C20.2041 3.87705 21.9278 4.59216 23.1991 5.86345C24.4703 7.13473 25.1854 8.85838 25.1875 10.6562V12.5938C25.1875 12.8507 25.0854 13.0971 24.9038 13.2788C24.7221 13.4604 24.4757 13.5625 24.2188 13.5625Z"
                              fill="#F98585"
                            />
                            <path
                              d="M16.4688 7.75018C16.2119 7.75013 15.9655 7.64803 15.7839 7.46634L13.8464 5.52884C13.6648 5.34717 13.5627 5.10081 13.5627 4.84393C13.5627 4.58706 13.6648 4.34069 13.8464 4.15903L15.7839 2.22153C15.8732 2.129 15.9801 2.0552 16.0983 2.00443C16.2165 1.95366 16.3436 1.92694 16.4723 1.92582C16.6009 1.9247 16.7285 1.94921 16.8475 1.99792C16.9666 2.04663 17.0747 2.11856 17.1657 2.20952C17.2567 2.30048 17.3286 2.40864 17.3773 2.5277C17.426 2.64675 17.4505 2.77432 17.4494 2.90295C17.4483 3.03158 17.4216 3.1587 17.3708 3.27689C17.32 3.39508 17.2462 3.50198 17.1537 3.59134L15.9011 4.84393L17.1537 6.09653C17.2891 6.23201 17.3814 6.4046 17.4187 6.59249C17.4561 6.78039 17.4369 6.97514 17.3636 7.15213C17.2903 7.32912 17.1662 7.4804 17.0069 7.58685C16.8476 7.6933 16.6604 7.75014 16.4688 7.75018Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 27.125H10.6562C9.37208 27.1235 8.14095 26.6126 7.2329 25.7046C6.32485 24.7966 5.81404 23.5654 5.8125 22.2812V18.4062C5.8125 18.1493 5.91456 17.9029 6.09624 17.7212C6.27792 17.5396 6.52432 17.4375 6.78125 17.4375C7.03818 17.4375 7.28458 17.5396 7.46626 17.7212C7.64794 17.9029 7.75 18.1493 7.75 18.4062V22.2812C7.75 23.052 8.05619 23.7913 8.60122 24.3363C9.14625 24.8813 9.88546 25.1875 10.6562 25.1875H12.5938C12.8507 25.1875 13.0971 25.2896 13.2788 25.4712C13.4604 25.6529 13.5625 25.8993 13.5625 26.1562C13.5625 26.4132 13.4604 26.6596 13.2788 26.8413C13.0971 27.0229 12.8507 27.125 12.5938 27.125Z"
                              fill="#F98585"
                            />
                            <path
                              d="M12.5938 29.0623C12.4022 29.0623 12.215 29.0054 12.0557 28.899C11.8964 28.7925 11.7723 28.6413 11.699 28.4643C11.6257 28.2873 11.6065 28.0925 11.6438 27.9046C11.6812 27.7167 11.7734 27.5441 11.9089 27.4087L13.1615 26.1561L11.9089 24.9035C11.7324 24.7208 11.6348 24.4761 11.637 24.2221C11.6392 23.968 11.7411 23.7251 11.9207 23.5455C12.1003 23.3658 12.3433 23.264 12.5973 23.2618C12.8513 23.2595 13.096 23.3572 13.2787 23.5337L15.2162 25.4712C15.3978 25.6528 15.4998 25.8992 15.4998 26.1561C15.4998 26.4129 15.3978 26.6593 15.2162 26.841L13.2787 28.7785C13.0971 28.9602 12.8507 29.0623 12.5938 29.0623Z"
                              fill="#F98585"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_2697_3748">
                              <rect width="31" height="31" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                      </span>
                    </button>
                  ) : null}
                  <ExtraDutyLogsheet
                    data={row}
                    depo={depo}
                    fetchData={fetchExtraDutys}
                    data1={data1}
                    data2={data2}
                    isDrv={false}
                    isCond={true}
                    isPresent={row.editsts === "1" ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      },
      sortable: true,
      width: "200px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Vehicle No.</span>
        </div>
      ),
      selector: (row) => row.busNO,
      cell: (row, index) => (
        <>
          {row.editsts === "1" ? (
            <>
              <div className="busno">
                <span>{row.busNo}</span>
              </div>
            </>
          ) : (
            <>
              <div className="busno">
                <input
                  className="custom-input"
                  style={{ width: "100px" }}
                  name="busNo"
                  type="text"
                  value={row.busNo}
                  onChange={(e) => handleSelectBusNo(e, row.workno)}
                  autoComplete="off"
                />
              </div>
              {row.workno === editDutyNo &&
                showBusList &&
                busList.length > 0 && (
                  <>
                    <div className="vech-list">
                      {Array.isArray(busList)
                        ? busList.map((item) => {
                            return (
                              <>
                                <button
                                  className="bus-item"
                                  onClick={(e) => {
                                    handleSelect(e, index, item.busNo);
                                  }}
                                >
                                  {item.busNo}
                                </button>
                              </>
                            );
                          })
                        : null}
                    </div>
                  </>
                )}
            </>
          )}
        </>
      ),
      sortable: true,
      // width: "150px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Delay Reason</span>
        </div>
      ),
      selector: (row) => row.delayReason,
      cell: (row, index) => (
        <>
          {row.editsts === "1" && row.busNO !== "NA" ? (
            <>
              <div className="busno">
                <span>{row.delayReason}</span>
              </div>
            </>
          ) : (
            <>
              {" "}
              <div className="busno">
                <select
                  name="delayReason"
                  id="delayReason"
                  value={row.delayReason}
                  onChange={(e) =>
                    handleInputChange(e, "delayReason", row.srNo, row.workno)
                  }
                >
                  <option value="14">Computer</option>
                  <option value="1/1">Driver</option>
                  <option value="1/2">Conductor</option>
                  <option value="2">Bus</option>
                  <option value="8">Scheduled Suspend</option>
                  <option selected value="9">
                    No Delay
                  </option>
                </select>
              </div>
            </>
          )}
        </>
      ),
      sortable: true,
    },
    {
      name: (
        <div className="theadcol-flex">
          <span>Start Time</span>
        </div>
      ),
      selector: (row) => row.dutyStartTime,
      cell: (row) => (
        <>
          <div className="routNo">
            {row.editsts === "1" ? (
              <>
                <span>{row.timeTo && row.timeTo.replace(".", ":")}</span>
              </>
            ) : (
              <>
                <input
                  className="custom-input"
                  style={{ width: "75px" }}
                  type="text"
                  onChange={(e) => handleInputChange(e, "timeTo", row.srNo)}
                />
              </>
            )}
          </div>
        </>
      ),
      sortable: true,
      // width: "100px",
    },
    {
      name: (
        <div className="theadcol-flex">
          <span></span>
          <span>Action</span>
        </div>
      ),
      selector: (row) => row.workno,
      cell: (row) => {
        return (
          <>
            {row.editsts !== "1" && (
              <>
                <div className="d-flex gap-2">
                  <div className="crew-action">
                    <button
                      className="transperent"
                      onClick={(e) => {
                        setDutyData(row);
                        setShow2(true);
                      }}
                      title="Save Changes"
                    >
                      <span>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          className="bi bi-upload"
                          viewBox="0 0 16 16"
                        >
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                          <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                        </svg>
                      </span>
                    </button>
                  </div>
                </div>
              </>
            )}
          </>
        );
      },
      sortable: true,
      width: "100px",
    },
  ];

  useEffect(() => {
    localStorage.setItem("draggedCondData", JSON.stringify(draggedCondDatas));
  }, [draggedCondDatas]);

  // Save dragged driver data to localStorage
  useEffect(() => {
    localStorage.setItem("draggedDrvData", JSON.stringify(draggedDrvDatas));
  }, [draggedDrvDatas]);

  const resetDrv = (workno) => {
    setDraggedDrvDatas((prevValues) =>
      prevValues.filter((item) => item.workno !== workno)
    );
    setExtraDuty((prevData) =>
      prevData.map((row) =>
        row.workno === workno
          ? { ...row, driverNo: "", driverPresenty: "0" }
          : row
      )
    );
    // fetchExtraDutys();
    setIsDrvChange(false);
  };
  const resetCond = (workno) => {
    setDraggedCondDatas((prevValues) =>
      prevValues.filter((item) => item.workno !== workno)
    );
    setExtraDuty((prevData) =>
      prevData.map((row) =>
        row.workno === workno
          ? { ...row, conductorNo: "", conductorPresenty: "0" }
          : row
      )
    );
    // fetchExtraDutys();
    setIsCondChange(false);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDraggedCondDatas([]);
      setDraggedDrvDatas([]);
      localStorage.removeItem("draggedCondData");
      localStorage.removeItem("draggedDrvData");
      setIsDrvChange(false);
      setIsCondChange(false);
    }, 60000);

    return () => clearTimeout(timeout);
  }, []);

  // Update Duty Conductor Function
  const updateDutyCon = () => {
    const draggedCondData = JSON.parse(localStorage.getItem("draggedCondData"));
    if (
      draggedCondData &&
      draggedCondData.filter(
        (item) => item.condNo === selectedCon && item.workno !== dutyData.workno
      ).length > 0
    ) {
      toast.warn("Conductor code is already added to another duty", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else if (
      draggedCondData.filter(
        (item) => item.condNo === selectedCon && item.workno === dutyData.workno
      ).length > 0
    ) {
      const newArr = extraDuty.map((item2, idx) => {
        if (dutyData.workno === item2.workno) {
          return { ...item2, conductorNo: selectedCon, conductorPresenty: "1" };
        }
        return item2;
      });
      setExtraDuty(newArr);
      setShow3(false);
      setIsCondChange(true);
      setChangedDuty(dutyData.workno);
    } else {
      const newArr = extraDuty.map((item2, idx) => {
        if (dutyData.workno === item2.workno) {
          return { ...item2, conductorNo: selectedCon, conductorPresenty: "1" };
        }
        return item2;
      });
      setExtraDuty(newArr);
      setShow3(false);
      setIsCondChange(true);
      setChangedDuty(dutyData.workno);
      setDraggedCondDatas((prevValues) => {
        const exists = prevValues.some(
          (item) => item.workno === dutyData.workno
        );
        if (exists) {
          return prevValues.map((item) =>
            item.workno === dutyData.workno
              ? { ...item, condNo: selectedCon }
              : item
          );
        } else {
          return [
            ...prevValues,
            {
              workno: dutyData.workno,
              condNo: selectedCon,
            },
          ];
        }
      });
    }
  };

  // Update Duty Driver Function
  const updateDutyDrv = () => {
    const draggedDrvData = JSON.parse(localStorage.getItem("draggedDrvData"));
    if (
      draggedDrvData &&
      draggedDrvData.filter(
        (item) =>
          item.driverNo === selectedDrv && item.workno !== dutyData.workno
      ).length > 0
    ) {
      toast.warn("Driver code is already added to another duty", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    } else {
      const newArr = extraDuty.map((item2, idx) => {
        if (dutyData.workno === item2.workno) {
          return { ...item2, driverNo: selectedDrv, driverPresenty: "1" };
        }
        return item2;
      });
      setExtraDuty(newArr);
      setShow4(false);
      setIsDrvChange(true);
      setChangedDuty(dutyData.workno);
      setDraggedDrvDatas((prevValues) => {
        const exists = prevValues.some(
          (item) => item.workno === dutyData.workno
        );
        if (exists) {
          return prevValues.map((item) =>
            item.workno === dutyData.workno
              ? { ...item, driverNo: selectedDrv }
              : item
          );
        } else {
          return [
            ...prevValues,
            {
              workno: dutyData.workno,
              driverNo: selectedDrv,
            },
          ];
        }
      });
    }
  };

  const today = new Date();
  const day = String(today.getDate()).padStart(2, "0");
  const month = String(today.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
  const year = today.getFullYear();

  let formattedDate = `${year}-${month}-${day}`;

  const handleAddExtraDuty = () => {
    const user = AuthService.getCurrentUser();
    const payload = {
      busNo: dutyData.busNo,
      dutyNo: dutyData.workno,
      driverNO: dutyData.driverNo,
      conductorNo: dutyData.conductorNo,
      transactiondate: formattedDate,
      userId: "1",
      flag: "1",
      locID: "10",
      contrillerId: user && user.controllerId,
      narration: "",
      DelayReason: dutyData.delayReason,
      TimeTo: dutyData.timeTo,
    };

    console.log(dutyData);

    if (
      dutyData.busNo !== "" &&
      dutyData.workno !== "" &&
      dutyData.driverNO !== "" &&
      dutyData.conductorNo !== "" &&
      dutyData.delayReason !== "" &&
      dutyData.timeTo !== ""
    ) {
      DutyPostingService.addExtraDuty(payload)
        .then((resp) => {
          if (resp.data) {
            fetchExtraDutys();
            getDrvList("1");
            toast.success("Extra Duty Added successfully", {
              position: "top-center",
              autoClose: 3000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
              onClose: () => setShow2(false),
            });
            // setShow2(false);
          }
        })
        .catch((e) => console.log(e));
    } else {
      toast.warn("*Please fill all required fields!", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  return (
    <>
      <div className="d-flex align-items-center gap-2">
        <div className="search-bar">
          <input
            type="text"
            placeholder="Click here to Search by Duty No./Driver or Conductor Code."
            name="search"
            value={search}
            onChange={handleSearch}
          />
          <div className="search-icon">
            <span>
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.8938 13.8677L17.5 17.5M15.8333 9.16667C15.8333 12.8486 12.8486 15.8333 9.16667 15.8333C5.48477 15.8333 2.5 12.8486 2.5 9.16667C2.5 5.48477 5.48477 2.5 9.16667 2.5C12.8486 2.5 15.8333 5.48477 15.8333 9.16667Z"
                  stroke="#A79EB7"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
          </div>
        </div>
        <button
          className="btn btn-primary"
          style={{ width: "150px" }}
          onClick={() => addRow()}
        >
          Add Extra Duty
        </button>
      </div>

      {/* <ToastContainer /> */}

      <div className="datatable">
        <DataTable
          columns={exColumns}
          data={filter ? filteredData : extraDuty}
          fixedHeader
        />
      </div>

      <Modal
        show={show2}
        onHide={() => {
          setShow2(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Extra Duty</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to add extra duty!</Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow2(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={handleAddExtraDuty}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show3}
        onHide={() => {
          setShow3(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Conductor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update Conductor to this duty!
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow3(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={updateDutyCon}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={show4}
        onHide={() => {
          setShow4(false);
        }}
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Driver</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to update driver to this duty!
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShow4(false);
            }}
          >
            No
          </Button>
          <Button variant="primary" onClick={updateDutyDrv}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ExtraDuty;
